import checkupIcon from '@disy/cadenza-icons/checkup.svg';
import { icon } from '@disy/ui/icon';

import type { WorkbookId } from 'cadenza/repository/model/workbook-id.gen';
import type { WorkbookVersion } from 'cadenza/workbook/api/workbook-version';
import { openWorkbookTestSuite } from 'cadenza/workbook/header/save-workbook-actions/open-workbook-test-suite-function';
import i18n from 'cadenza/workbook/workbook.properties';

export function createTestWorkbookAction(workbookId: WorkbookId, version?: WorkbookVersion, label?: string) {
  return {
    icon: icon(checkupIcon),
    label: label || i18n('testButton.label'),
    execute: () => openWorkbookTestSuite(workbookId, { version }),
  };
}
